import { QueryConfig } from "store/utils/query-config";

export const ccArticleDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdAt"]
  }
};
